import { isStoreDetails } from '@repo/types/store-details';
import { fetcher } from '@repo/utils';

export const getStore = async (basePath: string, buCode: string) => {
    const url = `${basePath}/${buCode}`;
    const req = await fetcher(url);
    const data = await req.json();
    return isStoreDetails(data) ? data : Promise.reject(new Error());
};
